import { DataLocalStorage } from '@wkda/funnel-utils';
export class VinResolutionState {
  storage;
  key = '';
  _unsubscribe = () => {};
  constructor(hash) {
    let storage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new DataLocalStorage();
    this.storage = storage;
    this.key = `vinResolveFailed_${hash}`;
  }
  get isResolutionFailed() {
    return this.storage.getItem(this.key) ?? false;
  }
  get resolutionFailedTimes() {
    return this.isResolutionFailed ? 1 : 0;
  }
  update(value) {
    this.storage.setItem(this.key, value);
  }
  observe(handler) {
    this._unsubscribe = this.storage.onChange(this.key, handler);
  }
  unsubscribe() {
    if (typeof this._unsubscribe === 'function') {
      this._unsubscribe();
    }
  }
}